  document.addEventListener("DOMContentLoaded", function () {
     let container = document.getElementById("color-swatches-container");

    function renderSwatchGroup(id, labelText, forceActiveColour = null) {
      let script = document.getElementById(id);
      if (!script) return;

      let data;
      try {
        data = JSON.parse(script.textContent);
      } catch (e) {
        console.warn(`Invalid JSON in ${id}`);
        return;
      }

      let list = data;
      let activeColour = forceActiveColour;

      // Nếu JSON là object có ListColour + ColourActive
      if (!Array.isArray(data) && data.ListColour && data.ColourActive) {
        list = data.ListColour;
        activeColour = forceActiveColour || data.ColourActive;
      }

      if (!Array.isArray(list) || list.length === 0) return;

      let label = document.createElement("label");
      label.textContent = labelText;
      label.style.fontWeight = "bold";
      label.style.display = "block";
      label.style.marginTop = "1rem";
      label.style.marginBottom = "0.5rem";
      container.appendChild(label);

      let listEl = document.createElement("div");
      listEl.style.display = "flex";
      listEl.style.gap = "10px";

      list.forEach(item => {
        let a = document.createElement("a");
        a.href = item.ProductLink || item.product_link || "#";
        a.title = item.ColourName || item.color_name;
        a.className = (item.ColourName === activeColour || item.color_name === activeColour) ? "swatch active" : "swatch";
        a.style.cssText = `
          background-color: ${item.ColourCode || item.color_code};
        `;
        listEl.appendChild(a);
      });

      container.appendChild(listEl);
    }

    // 1. Render essential & limited như bình thường
    renderSwatchGroup("essential-json", "ESSENTIAL COLOURS:");
    renderSwatchGroup("limited-json", "LIMITED EDITION:");

    // 2. Trích ColourActive từ list_color_product để làm label
    let listColorScript = document.getElementById("list_color_product");
    if (listColorScript) {
      try {
        let parsed = JSON.parse(listColorScript.textContent);
        let active = parsed.ColourActive || "N/A";
        renderSwatchGroup("list_color_product", `Colour: ${active}`, active);
      } catch (e) {
        console.warn("Invalid JSON in list_color_product");
      }
    }
  });